module.exports = __webpack_public_path__ + "static/media/prep.19b6522b.png";